module.exports = __webpack_public_path__ + "static/media/1.10c1f14b.jpg";